<template>
  <v-card elevation="0" width="100%" class="ma-0 pa-0">
    <v-dialog v-model="dialog" max-width="500">
      <Confirm
          title="Salvar"
          message="Tem certeza de que deseja salvar estes dados?"
          buttonText="Salvar"
          @cancel="dialog = false"
          @action="submit"
      />
    </v-dialog>

    <v-row cols="12" sm="12" md="12" lg="12" class="ma-0 pa-0">
      <v-col cols="12" sm="12" md="12" lg="12" class="mb-3">
        <label class="label-details-policy">Política de Troca e Devoluções</label>
        <section class="mt-1">
          <quill-editor
              :content="exchangeAndReturnsPolicy"
              @change="onEditorChangeExchangeAndReturnsPolicy($event)"
              ref="myQuill"
          >
          </quill-editor>
        </section>
      </v-col>

      <v-col cols="12" sm="12" md="12" lg="12" class="mb-3">
        <label class="label-details-policy">Política de Privacidade</label>
        <section class="mt-1">
          <quill-editor
              :content="privacyPolicy"
              @change="onEditorChangePrivacyPolicy($event)"
              ref="myQuill"
          >
          </quill-editor>
        </section>
      </v-col>

      <v-col cols="12" sm="12" md="12" lg="12" class="mb-3">
        <label class="label-details-policy">Termos e Condições</label>
        <section class="mt-1">
          <quill-editor
              :content="termsAndConditions"
              @change="onEditorChangeTermsAndConditions($event)"
              ref="myQuill"
          >
          </quill-editor>
        </section>
      </v-col>

      <v-col cols="12" sm="12" md="12" lg="12" class="mb-3">
        <label class="label-details-policy">Sobre a Loja Imprimax</label>
        <section class="mt-1">
          <quill-editor
              :content="aboutStore"
              @change="onEditorChangeAboutStore($event)"
              ref="myQuill"
          >
          </quill-editor>
        </section>
      </v-col>
    </v-row>

    <v-row class="pb-3" justify="center">
      <v-col cols="12" md="6">
        <v-btn
            class="primary-button"
            color="normalred"
            elevation="0"
            @click="submit()"
            block
        >
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Confirm from "../../components/ConfirmExit.vue";
import {VMoney} from "v-money";

export default {
  name: "PlatformPolicies",
  components: {
    Confirm,
  },
  props: {},
  data: () => ({
    outlined: true,
    apiService: new ApiService(),
    dialog: false,
    exchangeAndReturnsPolicy: '<p>Cadastre aqui a política de Troca e Devoluções</p>',
    privacyPolicy: '<p>Cadastre aqui a política de Privacidade</p>',
    termsAndConditions: '<p>Cadastre aqui os termos e Condições</p>',
    aboutStore: '<p>Cadastre aqui a sobre a Loja Imprimax</p>',
    platformSettings: {
      id: null,
      exchangeAndReturnsPolicy: null,
      privacyPolicy: null,
      termsAndConditions: null,
      aboutStore: null,
    },
    rules: {
      required: (value) => !!value || "Campo requerido.",
    },
  }),
  async created() {
    await this.getPlatformSettings();
  },
  methods: {
    onEditorChangeExchangeAndReturnsPolicy({quill, html, text}) {
      this.exchangeAndReturnsPolicy = html
    },
    onEditorChangePrivacyPolicy({quill, html, text}) {
      this.privacyPolicy = html
    },
    onEditorChangeTermsAndConditions({quill, html, text}) {
      this.termsAndConditions = html
    },
    onEditorChangeAboutStore({quill, html, text}) {
      this.aboutStore = html
    },
    async getPlatformSettings() {
      try {
        await this.apiService.get("platformsettings/get").then((response) => {
          if (response.body !== "") {
            this.platformSettings = response
            this.exchangeAndReturnsPolicy = this.platformSettings.exchangeAndReturnsPolicy ? this.platformSettings.exchangeAndReturnsPolicy : this.exchangeAndReturnsPolicy;
            this.privacyPolicy = this.platformSettings.privacyPolicy ? this.platformSettings.privacyPolicy : this.privacyPolicy;
            this.termsAndConditions = this.platformSettings.termsAndConditions ? this.platformSettings.termsAndConditions : this.termsAndConditions;
            this.aboutStore = this.platformSettings.aboutStore ? this.platformSettings.aboutStore : this.aboutStore;
          }
        });
      } catch (e) {
      }
    },
    async submit() {
      try {
        let urlMethod = "policies"
        let httpMethod = 'put'
        if (!this.platformSettings.id) {
          urlMethod = 'add'
          httpMethod = 'post'
          delete this.platformSettings.id
        }
        this.platformSettings.exchangeAndReturnsPolicy = this.exchangeAndReturnsPolicy;
        this.platformSettings.privacyPolicy = this.privacyPolicy;
        this.platformSettings.termsAndConditions = this.termsAndConditions;
        this.platformSettings.aboutStore = this.aboutStore;
        this.apiService[httpMethod](`platformsettings/${urlMethod}`, this.platformSettings)
            .then(async (resp) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: resp.message,
                trace: null,
              });
              await this.getPlatformSettings()
              this.dialog = false;
              this.loading = false;
            })
            .catch((err) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Erro",
                message: err.body.message,
                trace: null,
              });
              this.dialog = false;
              this.loading = false;
            });
      } catch (e) {

      }
    },
  },
};
</script>
<style scoped>
.label-details-policy {
  color: #bc0000;
  font-weight: 700;
  font-size: 16px;
}
</style>
